export default __webpack_public_path__ + "static/media/voltmeter-power-svgrepo-com.3539a28d.svg";